export const OneColumn = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.35 12.16L39.51 12.25L39.66 12.33L39.81 12.42L39.94 12.5L40.07 12.59L40.19 12.68L40.3 12.77L40.4 12.86L40.5 12.95L40.59 13.04L40.67 13.13L40.74 13.22L40.8 13.32L40.85 13.41L40.9 13.51L40.93 13.61L40.96 13.7L40.98 13.8L41 13.9L41 14L41 34L40.99 34.15L40.98 34.3L40.95 34.44L40.92 34.58L40.87 34.71L40.81 34.84L40.75 34.97L40.68 35.09L40.6 35.2L40.51 35.31L40.41 35.41L40.31 35.51L40.2 35.6L40.09 35.68L39.97 35.75L39.84 35.81L39.71 35.87L39.58 35.92L39.44 35.95L39.3 35.98L39.15 35.99L39 36L9 36L8.85 35.99L8.7 35.98L8.56 35.95L8.42 35.92L8.29 35.87L8.16 35.81L8.03 35.75L7.91 35.68L7.8 35.6L7.69 35.51L7.59 35.41L7.49 35.31L7.4 35.2L7.32 35.09L7.25 34.97L7.19 34.84L7.13 34.71L7.08 34.58L7.05 34.44L7.02 34.3L7.01 34.15L7 34L7 14L7.01 13.85L7.02 13.7L7.05 13.56L7.08 13.42L7.13 13.29L7.19 13.16L7.25 13.03L7.32 12.91L7.4 12.8L7.49 12.69L7.59 12.59L7.69 12.49L7.8 12.4L7.91 12.32L8.03 12.25L8.16 12.19L8.29 12.13L8.42 12.08L8.56 12.05L8.7 12.02L8.85 12.01L9 12L39 12L39.18 12.08L39.35 12.16ZM9 34L39 34L39 14L9 14L9 34Z"
    />
  </svg>
);

export const TwoColumnsEqual = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39 12C40.1046 12 41 12.8954 41 14V34C41 35.1046 40.1046 36 39 36H9C7.89543 36 7 35.1046 7 34V14C7 12.8954 7.89543 12 9 12H39ZM39 34V14H25V34H39ZM23 34H9V14H23V34Z"
    />
  </svg>
);

export const TwoColumnsOneThirdTwoThirds = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39 12C40.1046 12 41 12.8954 41 14V34C41 35.1046 40.1046 36 39 36H9C7.89543 36 7 35.1046 7 34V14C7 12.8954 7.89543 12 9 12H39ZM39 34V14H20V34H39ZM18 34H9V14H18V34Z"
    />
  </svg>
);

export const TwoColumnsTwoThirdsOneThird = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39 12C40.1046 12 41 12.8954 41 14V34C41 35.1046 40.1046 36 39 36H9C7.89543 36 7 35.1046 7 34V14C7 12.8954 7.89543 12 9 12H39ZM39 34V14H30V34H39ZM28 34H9V14H28V34Z"
    />
  </svg>
);

export const ThreeColumnsEqual = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      d="M41 14a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h30a2 2 0 0 0 2-2V14zM28.5 34h-9V14h9v20zm2 0V14H39v20h-8.5zm-13 0H9V14h8.5v20z"
    />
  </svg>
);

export const ThreeColumnsWideCenter = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      d="M41 14a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h30a2 2 0 0 0 2-2V14zM31 34H17V14h14v20zm2 0V14h6v20h-6zm-18 0H9V14h6v20z"
    />
  </svg>
);
